import React from "react";
import NavBar from "../../pageComponents/navigationBar/NavigationBar";
import MainAnalyticComponent from "./AnalyticComponent";

export default function MainAnalyticPage() {
  return (
    <>
      <NavBar />
      <div className="flex flex-row bg-muted/40">
        <MainAnalyticComponent/>
      </div>
    </>
  );
}